import { Constants } from '../_constants/shared.constants';
const initialState = {};
function manageProfileReducer(state = initialState, action) {
    switch (action.type) {
        case Constants.manageProfile.MANAGE_PROFILE:
            console.log("mana-----", action.data);
            return {
                ...state,
                data: action.data,
            };
        default:
            return state
    }
}
export default manageProfileReducer;